"use client";

import dynamic from "next/dynamic";

const ClientOnlyPage = dynamic(() => import("./detail-client"), {
  ssr: false,
  loading: () => null,
});

export default function ClientOnlyPageWrapper(props) {
  return <ClientOnlyPage {...props} />;
}
